import React from 'react';
import { Chip } from '@mui/material';
import type { StatusChipProps } from './label.types';
import { getStatusChipSx } from './label.styles';

const StatusChip: React.FC<StatusChipProps> = ({
  label,
  tone,
  size = 'small',
  icon,
  onClick
}) => (
  <Chip
    label={label}
    icon={icon as React.ReactElement | undefined}
    size="small"
    clickable={Boolean(onClick)}
    onClick={onClick}
    sx={getStatusChipSx(tone, size)}
    aria-label={label}
  />
);

export default StatusChip;
